export default __webpack_public_path__ + "static/media/shuvo2.0d2474e1.jpg";